import React from 'react';

import features from 'services/feature-manager';
import OverviewRow from '../OverviewRow';
import SportEventRow from './SportEventRow';

export { default as StreamStub } from './StreamStub';

const SportEventRowOrOverview: React.FC<
    PropsFromReactComponent<typeof SportEventRow>
> = ({ matchId, prevMatchId, ...rest }) => {
    const isSportEventRowOverview = features.isActive(
        features.list.MatchListSportEventRowOverview
    );

    return isSportEventRowOverview ? (
        <OverviewRow sportEventId={matchId} prevSportEventId={prevMatchId} />
    ) : (
        <SportEventRow matchId={matchId} prevMatchId={prevMatchId} {...rest} />
    );
};

export default SportEventRowOrOverview;
